import classNames from '@/external/classNames';

const Container: FC<{ position: number; isMyScore?: boolean }> = ({
  children,
  isMyScore,
}) => (
  <div
    className={classNames(
      'mb-1 grid h-8 grid-cols-[32px_repeat(2,1fr)] gap-x-1 border-b border-dashed border-hit px-2 py-0 text-moon-12 text-bulma last:border-none',
      isMyScore && 'font-medium',
    )}
  >
    {children}
  </div>
);

export default Container;
